import React from "react"
import PropTypes from 'prop-types'
import SampleTable from "../TableComponents/SampleTable";
import SampleTableHeader from "../TableComponents/SampleTableHeader";
import SampleTableContents from "../TableComponents/SampleTableContents";
import {GetSamples} from "../../utils/APIRequests";
import SamplePanel from "../SamplePanel/SamplePanel";
import DownloadAsPDF from "../../downloads/pdf/DownloadAsPDF";
import DownloadAsCSV from "../../downloads/DownloadAsCSV";
import DownloadAsDairyComp from "../../downloads/dairycomp/DownloadAsDairyComp";
import {GenerateFilename} from "../TableComponents/utils/table_helpers";
import FilterPanel from "../FilterPanel/FilterPanel";

export default class SampleStore extends React.Component{
	
	static defaultProps = {
		reportInfo: null,
		dairyName: null,
		samplesToDate: null,
		samplesFromDate: null
	}
	
	static propTypes = {
		reportInfo: PropTypes.object.isRequired,
		dairyName: PropTypes.string.isRequired,
		samplesToDate: PropTypes.string.isRequired,
		samplesFromDate: PropTypes.string.isRequired
	}
	
	constructor(props){
		super(props)
		
		this.state = {
			samplesLoaded: false,
			samples: [],
			samplesToDisplay: []
		}
	}
	
	fetchSamples(){
		const reportId = this.props.reportInfo.report_id
		const reportType = this.props.reportInfo.report_type
		const fromDate = this.props.samplesFromDate
		const toDate = this.props.samplesToDate
		
		GetSamples(reportType, reportId, fromDate, toDate, this.props.onRestrictedResponse, (samples) => {
			this.setState({
				samplesLoaded: true,
				samples: samples,
				samplesToDisplay: samples
			})
		})
	}
	
	shouldComponentUpdate(nextProps, nextState) {
		const reportInfoKeys = Object.keys(nextProps.reportInfo)
		
		for(let keyIndex = 0; keyIndex < reportInfoKeys.length; keyIndex++){
			if(nextProps.reportInfo[reportInfoKeys[keyIndex]] !== this.props.reportInfo[reportInfoKeys[keyIndex]]){
				return true
			}
		}
		
		const {samplesFromDate, samplesToDate} = this.props
		
		const fromDateCheck = samplesFromDate !== nextProps.samplesFromDate
		const toDateCheck = samplesToDate !== nextProps.samplesToDate
		
		const samplesLoadedCheck = this.state.samplesLoaded !== nextState.samplesLoaded
		
		const samplesToDisplayCheck = this.state.samplesToDisplay !== nextState.samplesToDisplay
		
		return fromDateCheck || toDateCheck || samplesLoadedCheck || samplesToDisplayCheck
	}
	
	componentDidUpdate(prevProps, prevState) {
		const { report_id } = this.props.reportInfo
		const { samplesFromDate, samplesToDate } = this.props
		
		if(
			report_id !== prevProps.reportInfo.report_id ||
			samplesFromDate !== prevProps.samplesFromDate ||
			samplesToDate !== prevProps.samplesToDate
		){
			this.setState({
				samplesLoaded: false
			}, () => (
				this.fetchSamples()
			))
		}
	}
	
	componentDidMount() {
		if(this.state.samplesLoaded){
			return
		}
		
		this.fetchSamples()
	}
	
	changeDisplaySamples(filteredSamples){
		this.setState({
			samplesToDisplay: filteredSamples
		})
	}
	
	render(){
		
		const { samplesToDisplay, samples } = this.state
		const { dairyName, reportInfo } = this.props
		
		return(
			<div>
				<SamplePanel title={"Filter Samples:"}>
					<FilterPanel
						samples={samples}
						filterSamples={this.changeDisplaySamples.bind(this)}
						reportType={reportInfo.report_type}
					/>
				</SamplePanel>
				<SamplePanel title={"Download Samples:"}>
					<button onClick={() => DownloadAsPDF(samplesToDisplay, dairyName, GenerateFilename(samplesToDisplay.length === 0 ? [] : samplesToDisplay[0].sample_type, dairyName))}>Save As PDF</button>
					<button onClick={() => DownloadAsCSV(samplesToDisplay, GenerateFilename(samplesToDisplay.length === 0 ? [] : samplesToDisplay[0].sample_type, dairyName))}>Save As Excel</button>
					<button onClick={() => DownloadAsDairyComp(samplesToDisplay)}>Save As DairyComp</button>
				</SamplePanel>
				<SampleTable>
					<SampleTableHeader reportType={reportInfo.report_type}/>
					<SampleTableContents samples={samplesToDisplay}/>
				</SampleTable>
			</div>
		)
	}
}